<template>
  <section>
    <h2 class="section-title">Ändringslogg</h2>

    <div class="audit-log-scroll">
      <AppTable>
        <thead>
          <tr>
            <th>Ändring inlagd</th>
            <th>Räntesats</th>
            <th>Bindningstid</th>
            <th>Gäller fr.o.m.</th>
            <th>Tillagd av</th>
          </tr>
        </thead>
        <tbody>
          <AppTableRow v-for="(entry, index) in rateAuditTrail" :key="index">
            <AppTableCell>{{ formatDateTimeValue(entry.createdAt) }}</AppTableCell>
            <AppTableCell>{{ formatPercentage(entry.interestRate) }}</AppTableCell>
            <AppTableCell>{{ translateInterestTerm(entry.interestTerm) }}</AppTableCell>
            <AppTableCell>{{ formatDateIfValid(entry.validFrom) ?? '-' }}</AppTableCell>
            <AppTableCell>{{ entry.addedByName || '-' }}</AppTableCell>
          </AppTableRow>
          <AppTableRow v-if="!rateAuditTrail.length">
            <AppTableCell colspan="5" class="text-center" :class="{ 'error-text': fetchRateAuditTrailError }">
              {{ emptyStateText }}
            </AppTableCell>
          </AppTableRow>
        </tbody>
      </AppTable>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { AppTable, AppTableRow, AppTableCell } from '@staff/ui'
import { formatDateIfValid, formatDateTimeValue, formatPercentage } from '@staff/shared'

import { usePricing } from '@/composables/usePricing'
import { useMetadata } from '@/composables/useMetadata'

const { rateAuditTrail, fetchAuditTrail, isFetchingRateAuditTrail, fetchRateAuditTrailError } = usePricing()
const { translateInterestTerm } = useMetadata()

const emptyStateText = computed(() => {
  if (isFetchingRateAuditTrail.value) return 'Hämtar ändringslogg...'
  if (fetchRateAuditTrailError.value)
    return `Kunde inte hämta ändringsloggen: ${fetchRateAuditTrailError.value.message}`
  return 'Ingen ändringslogg hittades'
})

onMounted(() => {
  fetchAuditTrail()
})
</script>

<style scoped lang="scss">
.section-title {
  margin-bottom: 16px;
}

.audit-log-scroll {
  max-height: 320px;
  overflow-y: auto;
}
</style>
